/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
import { MaterialSetting } from "../../components/material_helper/material_settings";
import { toast, ToastContainer } from "react-toastify";
import { Col, Row } from "reactstrap";
import { EditMaterialUrl } from "../../libs/env";

const GenMaterialForm = ({
  GenerateMaterial,
  data,
  setMaterialData,
  IsGenerating,
  UserActiveToggle,
  setShowSocketData,
  formData,
  setFormData,
  clearformData,
  setIsStopGenerating,
  IsStopGenerating,
  setIsRegenerating,
  setIsGenerating,
  generate_button,
}) => {
  let user_activation = window.sessionStorage.getItem("user_is_active");
  useEffect(() => {
    // Generate a random number to use as a suffix for the tab ID
    const randomSuffix = Math.floor(Math.random() * 1000000);

    // Create a unique tab ID by combining window.name and the random suffix
    const id = `${window.name}-${randomSuffix}`;

    // Set the tab ID state variable with the generated ID
    sessionStorage.setItem(`senderIDkey`, id);
  }, []);

  useEffect(() => {
    const channel = new BroadcastChannel(
      `tab-channel-${data?.user_id}`
    );
    if (IsGenerating) {
      channel.postMessage({
        type: "form-submitted",
        tabsenderKey: sessionStorage.getItem("senderIDkey"),
      });
    }
    channel.addEventListener("message", handleMessage);
  }, [IsGenerating, data]);

  function handleMessage(event) {
    const message = event.data;
    if (message.type === "form-submitted") {
      if (message.tabsenderKey !== sessionStorage.getItem("senderIDkey")) {
        // The message was sent from another tab
        setShowSocketData(false);
      } else {
        setShowSocketData(true);
      }
    }
  }

  const formSubmit = (event) => {
    event.preventDefault();
    if(window.location.pathname.includes(EditMaterialUrl))
    {
      clearformData("edit_temp");
    }
    else{
        clearformData();
    }
    if (user_activation === "true") {
      var isCredits;
      if (formData?.credits.includes("-")) {
        const minEstimation = formData?.credits.split("-")[0];
        isCredits = data?.remaining_credits >= minEstimation;
      } else {
        isCredits = data?.remaining_credits >= formData?.credits;
      }
      if (isCredits) {
        GenerateMaterial(formData);
      } else {
        toast.error(
          `*Insufficient credits: Add more credits for generate this Material`,
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            toastId: 1,
          }
        );
      }
    } else {
      UserActiveToggle();
    }
  };
  useEffect(() => {
    setMaterialData((MaterialData) => ({
      ...MaterialData,
      material_level: formData?.material_level ? formData?.material_level : "A1",
      material_id: formData?.material_id ? formData?.material_id : "",
      material_icon: data?.material_icon ? data?.material_icon : "",
      material_type: data?.material_type ? data?.material_type : "",
    }));
  }, [data,formData]);
  useEffect(() => {
    if (window.location.pathname.includes(EditMaterialUrl)) {
      setFormData((formData) => ({
        ...formData,
        level: data?.material_form_data?.level
          ? data?.material_form_data.level
          : "",
        age_group: data?.material_form_data?.age_group
          ? data?.material_form_data.age_group
          : "",
        objective: data?.material_form_data?.objective
          ? data?.material_form_data.objective
          : "",
        detail: data?.material_form_data?.detail
          ? data?.material_form_data.detail
          : "",
        material_id: data?.material_form_data?.material_id
          ? data?.material_form_data.material_id
          : "",
        credits: data?.material_form_data?.credits
          ? String(data?.material_form_data.credits)
          : "0",
      }));
    } else {
      setFormData((formData) => ({
        ...formData,
        material_id: data?.id ? data?.id : "",
        credits: data?.estimated_credits
          ? data?.estimated_credits
          : "1000",
      }));
    }
  }, [data]);
  const handleInputChange = (event) => {
    let { name, value } = event.target;
    if (user_activation === "true") {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    } else {
      UserActiveToggle();
    }
    if(window.location.pathname.includes(EditMaterialUrl))
    {
      clearformData("edit_temp");
    }
  };
  const handleScroll = (e) => {
    var timer;
    const container = e.target ;
    if (container)
    {
      container.classList.add('scrollable_scroll');
    }
    clearTimeout(timer);
    timer = setTimeout(() => {
      container.classList.remove('scrollable_scroll');
    }, 1000);
  };

  return (
    <form onSubmit={formSubmit}>
      <Row className="g-0 px-2">
        <div className="p-4">
          <div className="template_scroll" onScroll={handleScroll} >
            <div className="pb-2 ps-2">
              <h2 class="fs-5">
                <svg width="25" height="25" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0_5068_7784)">
                  <path d="M10.0625 4.375H10.4426C13.1089 4.375 14.4421 4.375 14.9482 4.85388C15.3856 5.26782 15.5795 5.87762 15.4614 6.46818C15.3248 7.15139 14.2363 7.92125 12.0595 9.46096L8.503 11.9765C6.32617 13.5162 5.23774 14.2861 5.10111 14.9693C4.983 15.5599 5.17686 16.1697 5.61432 16.5836C6.12039 17.0625 7.45356 17.0625 10.1199 17.0625H10.9375M7 4.375C7 5.82475 5.82475 7 4.375 7C2.92525 7 1.75 5.82475 1.75 4.375C1.75 2.92525 2.92525 1.75 4.375 1.75C5.82475 1.75 7 2.92525 7 4.375ZM19.25 16.625C19.25 18.0747 18.0747 19.25 16.625 19.25C15.1753 19.25 14 18.0747 14 16.625C14 15.1753 15.1753 14 16.625 14C18.0747 14 19.25 15.1753 19.25 16.625Z" stroke="#2E58D4" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>
                  </g>
                  <defs>
                  <clipPath id="clip0_5068_7784">
                  <rect width="21" height="21" fill="white"/>
                  </clipPath>
                  </defs>
                </svg>
                <b className="ps-2">Make your own version of this task </b>
              </h2>
            </div>
            <div>
              <MaterialSetting
                formData={formData}
                data={data}
                handleInputChange={handleInputChange}
                IsGenerating={IsGenerating}
              />
            </div>
          </div>
          <div className="col-12 d-flex align-items-center pt-3">
            <Col className="col-12 text-center px-2">
              {IsGenerating ? (
                <button
                  class="btn btn-darkblue px-4 rounded-5 fs-8"
                  type="button"
                  onClick={() => {
                    setIsStopGenerating(true)
                    setIsGenerating(false)
                    setIsRegenerating(false)
                  }}
                >
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Stop generating
                </button>
              ) : !IsGenerating && IsStopGenerating ? (
                <>
                  <button
                    class="btn btn-darkblue px-4 py-1 rounded-5 fs-8"
                    type="button"
                    onClick={() => {
                      setIsStopGenerating(false);
                      setIsGenerating(true);
                      setIsRegenerating(true);
                      generate_button();
                    }}
                  >
                    <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z" stroke="white" stroke-width="1.4719" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <b className="ps-1">Regenerate Task</b>
                  </button>
                  <button
                    type="submit"
                    rel="nofollow"
                    id="SubmitForm"
                    class="d-none"
                  >
                    <b>Regenerate</b>
                  </button>
                </>
              ) : (
                <button
                  type="submit"
                  href="#"
                  rel="nofollow"
                  id="SubmitForm"
                  class="btn btn-darkblue px-4  rounded-5 fs-18"
                >
                  <svg width="20" height="22" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.94185 1L1.38706 8.4815C1.13036 8.7745 1.002 8.921 1.00004 9.04472C0.998337 9.15228 1.04873 9.25461 1.13669 9.32222C1.23788 9.4 1.43837 9.4 1.83936 9.4H7.2059L6.46994 15L13.0247 7.5185C13.2814 7.2255 13.4098 7.079 13.4118 6.95528C13.4135 6.84772 13.3631 6.74539 13.2751 6.67777C13.1739 6.6 12.9734 6.6 12.5724 6.6H7.2059L7.94185 1Z" stroke="white" stroke-width="1.4719" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                  <b className="ps-1">Generate your own version</b>
                </button>
              )}
            </Col>
          </div>
        </div>
        <ToastContainer />
      </Row>
    </form>
  );
};

export default GenMaterialForm;
